import axios from "axios";
import { Response } from "@/shared/models/Response";
import { MedicalAppointment } from "../models/MedicalAppointment";
import { EventDataModel } from "@/modules/Profile/components/Appointment/models/EventDataModel";
import { VerifiedAppointmentsResponse } from "@/modules/Profile/components/Appointment/models/verified-response.model";

export class MedicalAppointmentService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_SCHEDULING_API}/medicalAppointment`;
  }

  async getDetail(id: string): Promise<Response<MedicalAppointment>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }
  async assignAppointment(
    medicalAppointment: MedicalAppointment,
    eventKey: string,
    eventList: EventDataModel[],
    patientId: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/`;
    const response = await axios.post(
      serviceUrl,
      { medicalAppointment, eventList },
      {
        params: { eventKey: eventKey, patientId }
      }
    );

    return response.data;
  }

  async cancelAppointment(
    id: string,
    eventKey: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}?eventKey=${eventKey}`;
    const response = await axios.delete(serviceUrl);

    return response.data;
  }

  async completeAppointment(
    id: string,
    eventKey: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}/complete/${eventKey}`;
    const response = await axios.post(serviceUrl);

    return response.data;
  }

  async verifyMedicalAppointmentsHoursScheduled(
    patientId: string,
    start: number,
    end: number,
    serviceTemp: string,
    filtering: boolean
  ): Promise<Response<VerifiedAppointmentsResponse | void>> {
    const serviceUrl = `${this.baseUrl}/verify-scheduled-hours`;

    const response = await axios.get(serviceUrl, {
      params: {
        patientId,
        start,
        end,
        serviceTemp,
        filtering
      }
    });

    return response.data;
  }
}
